<template>
    <div class="vh-animate vh-animate-fade-in">
        <Doughnut
            :data="{
                labels: dataLabels,
                datasets: [
                    {
                        backgroundColor: backgroundColor,
                        data: dataValues
                    }
                ]
            }"
            
            :options="{
                plugins:
                {
                    legend:
                    {
                        display: isLegendVisible,
                        position: 'bottom',
                    },
                    title:
                    {
                        display: isTitleVisible,
                    }
                },
            }"
            
            :style="style"
            />
    </div>
    
    
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'vue-chartjs';

ChartJS.register(ArcElement, Tooltip, Legend)

export default
{
    components:
    {
        Doughnut,
    },
    props:
    {
        title:
        {
            type: String,
            default: () => ''
        },
        dataLabels:
        {
            type: Array,
            default: () => {
                return [];
            }
        },
        dataValues:
        {
            type: Array,
            default: () => {
                return [];
            }
        },


        backgroundColor:
        {
            type: Array,
            default: () => [
                '#228CDB',
                '#26CC6E',
                '#FF9E0F',
                '#00C5CE',
            ]
        },
        borderWidth:
        {
            type: Number,
            default: 1,
        },

        isLegendVisible:
        {
            type: Boolean,
            default: true,
        },

        isTitleVisible:
        {
            type: Boolean,
            default: false,
        },

        usePercentage:
        {
            type: Boolean,
            default: false,
        },

        style:
        {
            type: Object,
            default: () => {}
        }
    },
};
</script>
